import { Box, ButtonBase, Tooltip } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { TitleText } from "~/components/Typographies";
import ApplicationsMenuPopper from "~/components/worksuite/ApplicationsMenuPopper";

const BrandMark = () => {
	const { t } = useTranslation("common");
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
	const open = Boolean(anchorEl);

	return (
		<>
			<Tooltip title={t("dock.switchModule")}>
				<ButtonBase
					aria-expanded={open}
					aria-haspopup="menu"
					aria-label={t("dock.switchModule")}
					onClick={(event) => setAnchorEl(event.currentTarget)}
					sx={{
						"&:hover": { backgroundColor: "action.hover" },
						alignItems: "center",
						borderRadius: 1.5,
						display: "flex",
						gap: 1,
						ml: { md: 0, xs: "calc(8px + env(safe-area-inset-left))" },
						px: 0.75,
						py: 0.5
					}}
				>
					<Box
						alt={t("shell.companyAlt")}
						component="img"
						src="/logos/company.svg"
						sx={{ flexShrink: 0, height: { md: 30, xs: 26 }, width: { md: 30, xs: 26 } }}
					/>
					<TitleText
						className="silverfern-font-wordmark"
						noWrap
						sx={{ color: "text.primary", fontSize: { md: "1.25rem", xs: "0.95rem" }, letterSpacing: "0.05em" }}
					>
						{t("home.sections.workSuite")}
					</TitleText>
				</ButtonBase>
			</Tooltip>
			<ApplicationsMenuPopper anchorEl={anchorEl} onClose={() => setAnchorEl(null)} placement="bottom-start" />
		</>
	);
};

export default BrandMark;
